export const REVIEWS_SEARCH_ID = 'reviews-search';

export const ALL_STAR_RATINGS = 'ALL_STAR_RATINGS';

export const INITIAL_PAGE_LIMIT = 8;
export const SUBSEQUENT_PAGE_LIMIT = 30;
export const ONE_STAR_RATING = 1;

export const SORT_BY_OPTION = {
  NEWEST: 'NEWEST',
  HIGHEST_RATING: 'HIGHEST_RATING',
  LOWEST_RATING: 'LOWEST_RATING',
  PHOTO_REVIEWS: 'PHOTO_REVIEWS',
} as const;

export const REVIEWS_DROPDOWN_ARIA_DESCRIPTION = {
  select: {
    ariaDescription: undefined,
  },
};

// TODO - refactor sorting options in when updating xapi

export const SORT_BY_OPTIONS = [
  {
    value: SORT_BY_OPTION.NEWEST,
    displayValue: 'Newest',
  },
  {
    value: SORT_BY_OPTION.HIGHEST_RATING,
    displayValue: 'Highest rating',
  },
  {
    value: SORT_BY_OPTION.LOWEST_RATING,
    displayValue: 'Lowest rating',
  },
  {
    value: SORT_BY_OPTION.PHOTO_REVIEWS,
    displayValue: 'Photo & video reviews',
  },
] as const;

export const FILTER_BY_OPTIONS = [
  {
    value: ALL_STAR_RATINGS,
    displayValue: 'All Reviews',
  },
  {
    value: 5,
    displayValue: '5 stars',
  },
  {
    value: 4,
    displayValue: '4 stars',
  },
  {
    value: 3,
    displayValue: '3 stars',
  },
  {
    value: 2,
    displayValue: '2 stars',
  },
  {
    value: 1,
    displayValue: '1 star',
  },
] as const;

export const SORT_BY_OPTIONS_V2 = {
  [SORT_BY_OPTION.NEWEST]: 'date:desc',
  [SORT_BY_OPTION.HIGHEST_RATING]: 'rating:desc',
  [SORT_BY_OPTION.LOWEST_RATING]: 'rating:asc',
  [SORT_BY_OPTION.PHOTO_REVIEWS]: 'photos:desc',
} as const;

export const ALL_STAR_RATINGS_VALUE = ALL_STAR_RATINGS;

export const BADGES_TOOLTIPS = {
  incentivizedReview:
    'This reviewer received an incentive to write this review. An incentive can be a coupon, sample product, sweepstakes entry, loyalty points, or other token of value in exchange for writing a review for this product.',
  staff:
    /**
     * @param {string} brand
     * @returns {string}
     */
    (brand: string) =>
      `Staff Contributor is someone who works on behalf of ${brand} and has been identified as someone who understands the product from the company’s perspective.`,
};

export const REVIEWS_REDIRECT_MAP = {
  writeAReview: '/shop/product/review/add',
} as const;

export const LOADING_STATE = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
} as const;

export const BV_SYNDICATED_INCENTIVIZED_REGEX_STR = '[This review was collected as part of a promotion.]';

export const DEFAULT_SYNDICATED_INCENTIVIZED_REVIEWS_BADGE_NAME = 'incentivizedReview';

export const DEFAULT_SYNDICATED_INCENTIVIZED_REVIEWS_BADGES = {
  [DEFAULT_SYNDICATED_INCENTIVIZED_REVIEWS_BADGE_NAME]: {
    contentType: 'REVIEW',
    badgeType: 'Custom',
    id: 'incentivizedReview',
  },
} as const;

export const DEFAULT_MCOM_NATIVE_USER_NICKNAME = "Macy's customer";
export const DEFAULT_BCOM_NATIVE_USER_NICKNAME = "Bloomingdale's customer";
export const DEFAULT_SYNDICATED_USER_NICKNAME = 'External reviewer';
